import { connect } from 'react-redux';
import ProgressTracker from './ProgressTracker';
import { progressTracker } from "../../../store/selectors/programs.selector";
import { updateProgressKPI, getProgressTracker } from "../../../store/actions/programs.actions";

const mapDispatchToProps = { updateProgressKPI, getProgressTracker};

const mapStateToProps = (state) => { 
    const programProgress = progressTracker(state);
    return { programProgress };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressTracker);